import React, { useState } from 'react';
import FormularioTurno from '../FormularioTurno';
import './AccionesRapidas.css';

const hoyISO = () => new Date().toISOString().slice(0, 10);

// Botones de acceso rápido del panel de inicio. No reimplementan ninguna
// funcionalidad: disparan los mismos modales/formularios que ya existen en
// App.js y Calendario.jsx.
function AccionesRapidas({ pacientes, onAgregarPaciente, onVerCalendario, onToggleSidebar, onTurnoCreado }) {
  const [modalTurno, setModalTurno] = useState(false);
  const [fechaTurno, setFechaTurno] = useState(hoyISO());

  const abrirModalTurno = () => {
    setFechaTurno(hoyISO());
    setModalTurno(true);
  };

  return (
    <div className="acciones-rapidas">
      <h3 className="acciones-rapidas-titulo">Acciones rápidas</h3>
      <div className="acciones-rapidas-grid">
        <button type="button" className="btn-accion-rapida" onClick={onAgregarPaciente}>
          <span className="accion-rapida-icono" aria-hidden="true">👤</span>
          Agregar paciente
        </button>
        <button type="button" className="btn-accion-rapida" onClick={abrirModalTurno}>
          <span className="accion-rapida-icono" aria-hidden="true">📅</span>
          Agregar turno/evento
        </button>
        <button type="button" className="btn-accion-rapida btn-accion-rapida-mobile" onClick={onToggleSidebar}>
          <span className="accion-rapida-icono" aria-hidden="true">📋</span>
          Ver listado de pacientes
        </button>
        <button type="button" className="btn-accion-rapida" onClick={onVerCalendario}>
          <span className="accion-rapida-icono" aria-hidden="true">🗓️</span>
          Ver calendario
        </button>
      </div>

      {modalTurno && (
        <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) setModalTurno(false); }}>
          <div className="modal-card modal-card-sm">
            <div className="modal-header">
              <h3>Agregar turno / evento</h3>
              <button className="modal-btn-cerrar" onClick={() => setModalTurno(false)}>✕</button>
            </div>
            <div className="modal-body">
              <FormularioTurno
                pacientes={pacientes}
                fecha={fechaTurno}
                onFechaChange={setFechaTurno}
                onCreado={(cita) => onTurnoCreado?.(cita)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccionesRapidas;
